/**
 * =====================================================
 * Product Slider.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Questo file risolve il conflitto del "doppio click" sui 
 * dispositivi mobili (in particolare iOS/Safari) causato 
 * da script di terze parti (es. Cloudflare Turnstile) e 
 * dalla gestione degli stati di hover del browser. 
 * Intercettando l'evento 'touchstart', il codice bypassa 
 * i ritardi di WebKit forzando il 'click' immediato sui 
 * pulsanti critici (come l'aggiunta al carrello e altri 
 * bottoni definiti), rendendo l'interazione istantanea.
 *
 * Note:
 * - Non dipendere da altri satelliti, solo da main.js
 * - Il caricamento condizionale avviene tramite la
 *   variabile globale `isTemplate` passata da PHP
 *   tramite WP_PARAMS.is_page_template.
 * - Tutte le funzioni dovrebbero essere incapsulate
 *   all'interno di ventura o di closure locali.
 *
 * Esempio di utilizzo:
 *   ventura.checkoutInit();
 *
 * =====================================================
 */
const ventura = window.ventura;
window.isTemplate = window.WP_PARAMS ? window.WP_PARAMS.is_page_template : null;

(function($) {

    ventura.activeSliderProducts = function() {
        $(".slider-products ul").slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    },
                },
            ],
        });
    };



    $(document).on('venturaReady', function() {
        ventura.activeSliderProducts();
        
        window.addEventListener('resize', function() {

        });
    });

})(jQuery);